import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button, FeaturedIconOutline, Modal } from "@unified-checkout/design-system";
import { Flag } from "@unified-checkout/design-system/icons/index";
import type { IButton } from "libs/design-system/src/types/Button/button";

import { FeatureListingItem } from "../components/FeatureListingItem";

import lightbulbImgSrc from "../assets/light-bulb.png";
import cardImgSrc from "../assets/card.png";
import chartsImgSrc from "../assets/charts.png";
import rocketImgSrc from "../assets/rocket.png";
import { ReactComponent as Clouds } from "../assets/faded-clouds.svg";

import styles from "./welcome-step.module.scss";


export const WelcomeStep = ({
  onNextHandler,
  onDismissHandler
}: {
  onNextHandler: () => void,
  onDismissHandler: () => void
}) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(true);

  const featuresIcons = [
    cardImgSrc,
    chartsImgSrc,
    rocketImgSrc
  ];

  const featuresList = t('innerLayout.dashboardGuide.welcomeStep.sellingPoints', { returnObjects: true });

  const actionBtnsProps: IButton[] = [
    {
      size: "lg",
      text: t('innerLayout.dashboardGuide.welcomeStep.letsGetStarted'),
      onClickHandler: () => (setIsOpen(false), onNextHandler())
    },
    {
      size: "sm",
      color: "secondary",
      variant: "link",
      text: t('innerLayout.dashboardGuide.welcomeStep.willExploreMyOwn'),
      onClickHandler: () => (setIsOpen(false), onDismissHandler())
    }
  ];


  return (
    isOpen &&
    <div className={styles['welcome-step-modal']}>
      <Modal
        open={isOpen}
        position="center"
        width="36.25rem"
      >
        <div className={styles['welcome-step']} tabIndex={-1}>
          <div className={styles['welcome-step__sidebar']}>

            <div className={styles['welcome-step__sidebar__light-bulb']}>
              <img src={lightbulbImgSrc} alt="Light Bulb" />
            </div>

            <div className={styles['welcome-step__sidebar__text-box']}>
              <div className={styles['welcome-step__sidebar__text-box__title']}>
                {t('innerLayout.dashboardGuide.welcomeStep.letUsGuideU')}
              </div>
              <div className={styles['welcome-step__sidebar__text-box__hint']}>
                {t('innerLayout.dashboardGuide.welcomeStep.willTakeAMinute')}
              </div>
            </div>

            <div className={styles['welcome-step__sidebar__clouds']}>
              <Clouds />
            </div>
          </div>

          <div className={styles['welcome-step__main-content']}>
            <FeaturedIconOutline
              size="xl"
              color="brand"
              icon={Flag}
            />

            <div className={styles['welcome-step__main-content__text-box']}>

              <div className={styles['welcome-step__main-content__text-box__title']}>
                {t('innerLayout.dashboardGuide.welcomeStep.welcomeToPaymob')}
              </div>

              <div className={styles['welcome-step__main-content__text-box__paragraph']}>
                {t('innerLayout.dashboardGuide.welcomeStep.everythingUNeed')}
              </div>
            </div>

            <div className={styles['welcome-step__main-content__features-listing']}>
              {
                featuresList.map((item: any, i: number) =>
                  <FeatureListingItem
                    key={i}
                    {...item}
                    imgSrc={featuresIcons[i]}
                  />
                )
              }
            </div>

            <div className={styles['welcome-step__main-content__actions-box']}>
              {
                actionBtnsProps.map((btnProps, i) =>
                  <Button
                    key={i}
                    {...btnProps}
                  />
                )
              }
            </div>

          </div>
        </div>

      </Modal>
    </div>
  )
};